<div class="anchor-link" (click)="removeControls()">{{entry?.formControlAttributes?.label}}</div>
  